import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export default function ContributeModal({ obituary, memberName, onClose, onSubmit }) {
  const [content, setContent] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    onSubmit({ content });
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="contribute-modal">
      <div className="bg-white rounded-lg shadow-floating max-w-2xl w-full">
        <div className="bg-paper border-b border-border p-6 flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-serif text-foreground">Add Your Memory</h2>
            <p className="text-sm font-sans text-foreground-muted mt-1">About {memberName}</p>
          </div>
          <button onClick={onClose} className="text-foreground-muted hover:text-primary" data-testid="close-modal-btn">
            <X className="w-6 h-6" strokeWidth={1.5} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-6">
            <Label htmlFor="content" className="font-sans text-foreground mb-2 block">Your Memory or Tribute</Label>
            <Textarea
              id="content"
              data-testid="contribution-input"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              className="bg-transparent border border-border focus:border-primary rounded-lg p-3 font-sans min-h-[150px]"
              placeholder="Share a memory, story, or tribute..."
              required
            />
          </div>

          <div className="flex justify-end space-x-3">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              data-testid="cancel-btn"
              className="border-2 border-primary/20 text-primary hover:bg-primary/5 rounded-full px-6 py-2 font-serif tracking-wide"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              data-testid="submit-contribution-btn"
              className="bg-primary text-primary-foreground hover:bg-primary-hover rounded-full px-6 py-2 font-serif tracking-wide"
            >
              Add Contribution
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}